import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss'],
})
/**
 * Code verification template
 */
export class VerificationComponent {
  @Input() formGroup!: UntypedFormGroup;
  @Output() clickSubmit = new EventEmitter<any>();
  /**
   * Action to take when submit button is clicked
   */
  onSubmit() {
    this.clickSubmit.emit();
  }
}
